import { HttpResponse, http, type HttpHandler } from 'msw';
import { BFF_ENDPOINTS } from '../../api/endpoints/BffEndpoints';
import { createMockSubscription, createMockCancellation } from '../../mocks/factories';
import { toMSWPattern } from '../utils/generic';
import type { HTTP_METHODS } from './constants/generic';
import { HTTP_METHODS_VALUES } from './constants/generic';

interface HandlerMapping {
  pattern: string;
  key: string;
  method?: HTTP_METHODS;
}

export interface HandlerWithMapping {
  handler: HttpHandler;
  mapping: HandlerMapping;
}

export const ENDPOINTS_KEYS = {
  SUBSCRIPTION: 'SUBSCRIPTION',
  CANCEL_SUBSCRIPTION: 'CANCEL_SUBSCRIPTION',
};

export function createSubscriptionHandlers(baseUrl: string): HandlerWithMapping[] {
  const handlers: HandlerWithMapping[] = [
    {
      handler: http.get(`${baseUrl}/${toMSWPattern(BFF_ENDPOINTS.SUBSCRIPTION)}`, () => {
        const subscription = createMockSubscription();
        return HttpResponse.json(subscription);
      }),
      mapping: {
        pattern: 'subscription',
        key: ENDPOINTS_KEYS.SUBSCRIPTION,
        method: HTTP_METHODS_VALUES.GET as HTTP_METHODS,
      },
    },
    {
      handler: http.post(`${baseUrl}/${toMSWPattern(BFF_ENDPOINTS.CANCEL_SUBSCRIPTION)}`, () => {
        const cancellation = createMockCancellation({ status: 'COMPLETED' });
        return HttpResponse.json({
          status: cancellation.status,
          effectiveDate: cancellation.effectiveDate,
        });
      }),
      mapping: {
        pattern: 'cancel_subscription',
        key: ENDPOINTS_KEYS.CANCEL_SUBSCRIPTION,
        method: HTTP_METHODS_VALUES.POST as HTTP_METHODS,
      },
    },
  ];
  return handlers;
}

